export const engagementCampaignsExperimentDataCampaignId = "/engagement/campaigns/experiment_data/:campaign_id";
